var map = {
	"./ATS-Green.png": 47029,
	"./ATS-Red.png": 74313,
	"./ATS-Yellow.png": 44269,
	"./BATT-Green.png": 77738,
	"./BATT-Red.png": 82072,
	"./BATT-Yellow.png": 86277,
	"./BL-Green.png": 83667,
	"./BL-Red.png": 97523,
	"./BL-Yellow.png": 72636,
	"./CP-Green.png": 28863,
	"./CP-Red.png": 55416,
	"./CP-Yellow.png": 80112,
	"./DSM-Green.png": 80631,
	"./DSM-Red.png": 78935,
	"./DSM-Yellow.png": 97855,
	"./ELB-Green.png": 31577,
	"./ELB-Red.png": 24360,
	"./ELB-Yellow.png": 73455,
	"./ELP-Green.png": 37880,
	"./ELP-Red.png": 69940,
	"./ELP-Yellow.png": 6102,
	"./EP-Green.png": 19731,
	"./EP-Red.png": 60332,
	"./EP-Yellow.png": 39159,
	"./EQ-Green.png": 66782,
	"./EQ-Red.png": 62273,
	"./EQ-Yellow.png": 50729,
	"./EXM-Green.png": 40025,
	"./EXM-Red.png": 83719,
	"./EXM-Yellow.png": 34589,
	"./LC-Green.png": 98973,
	"./LC-Red.png": 11234,
	"./LC-Yellow.png": 75664,
	"./OW-Green.png": 12415,
	"./OW-Red.png": 46997,
	"./OW-Yellow.png": 22266,
	"./RB-Green.png": 86177,
	"./RB-Red.png": 20776,
	"./RB-Yellow.png": 79438,
	"./RG-Green.png": 73908,
	"./RG-Red.png": 44931,
	"./RG-Yellow.png": 86865,
	"./RS-Green.png": 97445,
	"./RS-Red.png": 1502,
	"./RS-Yellow.png": 9797,
	"./SID-Green.png": 53757,
	"./SID-Red.png": 87795,
	"./SID-Yellow.png": 23528,
	"./SIH-Green.png": 56480,
	"./SIH-Red.png": 81338,
	"./SIH-Yellow.png": 9246,
	"./SM-Green.png": 9721,
	"./SM-Red.png": 43123,
	"./SM-Yellow.png": 91848,
	"./TE-Green.png": 761,
	"./TE-Red.png": 68278,
	"./TE-Yellow.png": 98888,
	"./TI-Green.png": 51292,
	"./TI-Red.png": 47055,
	"./TI-Yellow.png": 74390,
	"./TST-Green.png": 67942,
	"./TST-Red.png": 58065,
	"./TST-Yellow.png": 63722,
	"./V-Green.png": 46497,
	"./V-Red.png": 25837,
	"./V-Yellow.png": 60168,
	"./VG-Green.png": 44078,
	"./VG-Red.png": 17517,
	"./VG-Yellow.png": 36455,
	"./VM-Green.png": 9514,
	"./VM-Red.png": 97889,
	"./VM-Yellow.png": 11935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62759;